import { FormCQSelect } from '@laxmimanogna/code-quick-components';
import React from 'react';
import { Text } from '@chakra-ui/react';
import { STATES } from '../../../../constants/constants';

function StateDropDown(props) {
  const { control, errors, onChange, value,width,zIndex } = props;
  return (
    <>
      <FormCQSelect
        control={control}
        options={STATES}
        value={value}
        styles={{
          control: styles => ({
            ...styles,
            height: '50px',
            width: width ? width : '20rem',
            borderRadius: '5px',
            border: `1px solid rgba(0,0,0,0.1)`,
            zIndex: 99,
          }),
          menu: (provided, state) => ({
            ...provided,
            zIndex: 9999999,
          }),
        }}
        id={'state'}
        name={'state'}
        placeholder="Select State"
        variant="primary"
        onChange={onChange}
        isSearchable={true}
      />
      {errors['state'] && errors['state']['label'] && (
        <Text color={'red'}>State is required.</Text>
      )}
    </>
  );
}
export default StateDropDown;
